import { getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function verifyUser(email, code) {
    try {
        await getSignUpAuth().confirmSignUp(email.toLowerCase(), code, { forceAliasCreation: false });
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
